import React, { useState, useEffect } from "react";
import {
  addDomainCondition,
  sendDocumentDomainTerm,
  skipAllConditionalDomain,
} from "features/common/layouts/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  notifyWarning,
  notifyError,
  notifySuccess,
} from "components/ToastMessage";
import ModalAccordionByDomain from "./ModalAccordionByDomain";

const ModalConditionalDomain = (props) => {
  const dispatch = useDispatch();
  const { conditionalDomain } = useSelector((state) => state.cart);
  const [files, setFiles] = useState([]);
  const [sekolah, setSekolah] = useState("formal");
  const [loading, setLoading] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [submitted, setSubmitted] = useState(0);

  const handleFileChange = (event) => {
    const imageFile = event.target.files[0];
    const fileName = event.target.name;

    let fileArr = [...files];
    const existingFileIndex = fileArr.findIndex(
      (file) => file.domain_value === fileName
    );
    if (existingFileIndex !== -1) {
      // Replace existing file with the new one
      fileArr[existingFileIndex] = {
        domain_value: fileName,
        domain_upload: imageFile,
        domain_name: props.domain,
      };
    } else {
      // Add new file to the array
      fileArr.push({
        domain_value: fileName,
        domain_upload: imageFile,
        domain_name: props.domain,
      });
    }
    setFiles(fileArr);
  };

  const handlerSkipAll = () => {
    dispatch(skipAllConditionalDomain(true));
  };

  const handlerSendDocument = (e) => {
    e.preventDefault();
    if (props.tld === ".co.id") {
      const requiredFiles = ["coid-ktp", "coid-siup"];
      for (const file of requiredFiles) {
        if (!files.some((name) => name.domain_value === file)) {
          notifyWarning(`File KTP atau Surat kosong!`);
          return;
        }
      }
    } else if (props.tld === ".sch.id") {
      if (sekolah === "formal") {
        const requiredFiles = ["schid-surat", "schid-ktp"];
        for (const file of requiredFiles) {
          if (!files.some((name) => name.domain_value === file)) {
            notifyWarning(`File KTP atau Surat kosong!`);
            return;
          }
        }
      } else {
        const requiredFiles = ["schid-sk-non", "schid-ktp-non"];
        for (const file of requiredFiles) {
          if (!files.some((name) => name.domain_value === file)) {
            notifyWarning(`File KTP atau Surat kosong!`);
            return;
          }
        }
      }
    } else if (props.tld === ".ac.id") {
      const requiredFiles = ["acid-ktp", "acid-sk"];
      for (const file of requiredFiles) {
        if (!files.some((name) => name.domain_value === file)) {
          notifyWarning(`File KTP atau Akta kosong!`);
          return;
        }
      }
    } else if (props.tld === ".or.id") {
      const requiredFiles = ["orid-ktp", "orid-akta"];
      for (const file of requiredFiles) {
        if (!files.some((name) => name.domain_value === file)) {
          notifyWarning(`File KTP atau Akta kosong!`);
          return;
        }
      }
    } else if (props.tld === ".ponpes.id") {
      const requiredFiles = ["ponpes-ktp", "ponpes-surat"];
      for (const file of requiredFiles) {
        if (!files.some((name) => name.domain_value === file)) {
          notifyWarning(`File KTP atau Surat kosong!`);
          return;
        }
      }
    }
    // else if (props.tld === ".web.id") {
    //   const requiredFiles = ["webid-ktp"];
    //   for (const file of requiredFiles) {
    //     if (!files.some((name) => name.domain_value === file)) {
    //       notifyWarning(`File KTP kosong!`);
    //       return;
    //     }
    //   }
    // }
    else {
      const requiredFiles = ["international-document"];
      for (const file of requiredFiles) {
        if (!files.some((name) => name.domain_value === file)) {
          notifyWarning(`Your file document is empty!`);
          return;
        }
      }
    }
    for (const file of files) {
      if (file.domain_upload.size > 2 * 1024 * 1024) {
        notifyError(
          "Harap periksa ukuran file Anda. Ukuran maksimal yang diperbolehkan adalah 2MB."
        );
        return;
      }

      if (
        file.domain_upload.type !== "image/jpg" &&
        file.domain_upload.type !== "image/png" &&
        file.domain_upload.type !== "image/jpeg" &&
        file.domain_upload.type !== "application/pdf"
      ) {
        notifyError(
          "Maaf, hanya file dengan ekstensi PNG, JPG, JPEG, dan PDF yang diperbolehkan."
        );
        return;
      }
    }

    setDisabledButton(true);
    setLoading(true);
    dispatch(sendDocumentDomainTerm(files));
    setFiles([]);
  };

  useEffect(() => {
    if (conditionalDomain.status === "fulfilled") {
      setLoading(false);
      setDisabledButton(false);
      notifySuccess(
        `Kelengkapan Domain Bersyarat ${props.tld} Berhasil di Upload!`
      );
      dispatch(addDomainCondition({ status: "idle" }));
      setSubmitted(submitted + 1);
      if (submitted === props.tldArr.length - 1) {
        dispatch(addDomainCondition({ label: "Sudah Lengkap" }));
      }
      props.onHide();
    } else if (conditionalDomain.status === "error") {
      setLoading(false);
      setDisabledButton(false);
      notifyError(`${conditionalDomain.error}`);
      dispatch(addDomainCondition({ status: "idle" }));
    } else if (conditionalDomain.status === "idle") {
      setLoading(false);
      setDisabledButton(false);
    }
  }, [
    conditionalDomain.status,
    conditionalDomain.error,
    dispatch,
    props,
    submitted,
  ]);

  return (
    <ModalAccordionByDomain
      show={props.show}
      onHide={props.onHide}
      domain={props.domain}
      tld={props.tld}
      tldArr={props.tldArr}
      syarat={props.syarat}
      handleFileChange={handleFileChange}
      handlerSendDocument={handlerSendDocument}
      handlerSkipAll={handlerSkipAll}
      loading={loading}
      disabledButton={disabledButton}
      setSekolah={setSekolah}
    />
  );
};

export default ModalConditionalDomain;
